<template>
  <div class="school-selector text-dark" v-if="userSchoolsSorted.length > 1">
    <DDropdown :isShowDots="false" :propOffset="[0, 8]">
      <template #title>
        <button
          class="do-bttn do-bttn--with-icon">
          {{ selectedTitle }}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon tw-icon-cheveron-selection">
            <path fill-rule="evenodd"
                  d="M8.7 9.7a1 1 0 1 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 1 1-1.4 1.4L12 6.42l-3.3 3.3zm6.6 4.6a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
                  class="secondary"></path>
          </svg>
        </button>
      </template>
      <template #list>
        <ul class="school-selector__list text-dark" @click.stop>
          <li v-for="school in userSchoolsSorted"
              :key="school.id"
              class="school-selector__list__item"
              :class="{'school-selector__list__item--disabled': school.v_has_permission}"
              @click="toggleSchool(school)">
            {{ school.name }}
            <svg v-if="school.v_is_selected" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                 class="tw-icon icon-check">
              <circle cx="12" cy="12" r="10" class="primary"/>
              <path class="secondary"
                    d="M10 14.59l6.3-6.3a1 1 0 0 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-3-3a1 1 0 0 1 1.4-1.42l2.3 2.3z"/>
            </svg>
          </li>
        </ul>
      </template>
    </DDropdown>
  </div>
</template>

<script>
import DDropdown from './DDropdown.vue'

export default {
  components: {DDropdown},
  props: {
    schools: {
      type: Array,
      default: []
    },
    selectedSchoolIds: {
      type: Array,
      default: []
    },
    permission: {
      default: 'can_manage_salary'
    }
  },
  computed: {
    activeSchool () {
      return this.$store.state.activeSchool
    },
    selectedTitle () {
      if (this.selectedSchoolIds.length === 0) {
        return 'Vælg skole'
      }
      if (this.selectedSchoolIds.length === 1) {
        const id = this.selectedSchoolIds[0]
        const school = this.schools.find(school => school.id === id)
        return school ? school['name'] : 'Unavngiven skole'
      }
      if (this.selectedSchoolIds.length > 1) {
        return this.selectedSchoolIds.length + ' skoler valgt'
      }
    },
    userSchoolsSorted () {
      console.log('this.schools', this.schools)
      return this.schools
        .filter(school => this.getHasPermission(school))
        .map(school => ({
          ...school,
          v_is_selected: this.getIsSelected(school)
        }))
        .sort((a, b) => a.name.localeCompare(b.name))
    },
    userMemberships () {
      return this.$store.getters.userSchools
    }
  },
  methods: {
    toggleSchool (school) {
      this.$emit('toggleSchool', school)
    },
    getIsSelected (school) {
      return this.selectedSchoolIds.includes(school.id)
    },
    getHasPermission (school) {
      const schoolMember = this.userMemberships[school.id]
      if (!schoolMember) {
        return false
      }
      return schoolMember['permissions'].indexOf(this.permission) > -1
    },
    onSelectionChange () {
      this.$emit('schools-changed', this.selectedSchoolIds)
    }
  }
}
</script>

<style scoped>
.school-selector {
  position: relative;
}

.school-selector__list__item .tw-icon {
  width: 1.5rem;
}

.school-selector__list__item .tw-icon .primary {
  fill: transparent;
}

.school-selector__list__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 220px;
}

.school-selector .do-bttn  {
  min-width: 220px;
  justify-content: space-between;
  font-size: 1rem;
}

</style>



// WEBPACK FOOTER //
// SchoolsSelector.vue?080bbb96